/* Inkaroo designer v2 (in-theme, no app). Fabric.js 5 is loaded on demand.
   v2: touch scrolling over the garment, print position picker, first print included + extra print lines.
   v3 (mobile): the dashed print box follows the chosen position, smooth clamping (no snapping or jumps on release),
   big touch handles, drag without page scroll, pinch/rotate, swipe off the design to scroll. */
(function () {
  'use strict';
  var FONTS = { 'Anton': 400, 'Bebas Neue': 400, 'Montserrat': 700, 'Oswald': 600, 'Pacifico': 400, 'Permanent Marker': 400, 'Playfair Display': 700 };
  var FONT_CSS = 'https://fonts.googleapis.com/css2?family=Anton&family=Bebas+Neue&family=Montserrat:wght@700&family=Oswald:wght@600&family=Pacifico&family=Permanent+Marker&family=Playfair+Display:wght@700&display=swap';
  var INKS = [['Black', '#111111'], ['White', '#FFFFFF'], ['Gold', '#D4AF37'], ['Red', '#C15045'], ['Navy', '#1F2A44'], ['Royal blue', '#2456A6'], ['Green', '#2E7D32'], ['Pink', '#F4A6C1'], ['Yellow', '#F5D90A'], ['Orange', '#F28C28'], ['Grey', '#8A8A8A']];
  var OUTLINES = [['No outline', ''], ['Black outline', '#111111'], ['White outline', '#FFFFFF'], ['Gold outline', '#D4AF37']];
  // Print positions. Boxes are in cm inside a 30cm-wide print area (top-left origin), clipped to the real area.
  var BASE_ZONES = {
    front: [
      { id: 'left_chest', name: 'Left chest', size: 'S', hint: '~10cm', box: [18, 3, 10, 10] },
      { id: 'right_chest', name: 'Right chest', size: 'S', hint: '~10cm', box: [2, 3, 10, 10] },
      { id: 'centre_chest', name: 'Centre chest', size: 'A4', hint: 'A4 · ~21 × 30cm', box: [4.5, 2, 21, 30] },
      { id: 'full_front', name: 'Full front', size: 'A3', hint: 'A3 · ~30 × 40cm', box: [0, 0, 30, 40] }
    ],
    back: [
      { id: 'upper_back', name: 'Upper back / neck', size: 'S', hint: '~30 × 10cm', box: [0, 0, 30, 10] },
      { id: 'standard_back', name: 'Standard back', size: 'A4', hint: 'A4 · ~21 × 30cm', box: [4.5, 3, 21, 30] },
      { id: 'full_back', name: 'Full back', size: 'A3', hint: 'A3 · ~30 × 40cm', box: [0, 0, 30, 40] }
    ]
  };
  var BASE_DEFAULT = { front: 'centre_chest', back: 'standard_back' };
  // Per-product overrides come from the inkaroo.print_area metafield (sides, zones). One designer per page.
  var ZONES = BASE_ZONES, DEFAULT_ZONE = BASE_DEFAULT, CUSTOM = { front: false, back: false }, SIDES = ['front', 'back'];
  function applyPrintArea(pa) {
    if (typeof pa === 'string') { try { pa = JSON.parse(pa); } catch (e) { pa = null; } }
    pa = pa || {};
    SIDES = (Array.isArray(pa.sides) && pa.sides.length ? pa.sides : ['front', 'back']).filter(function (v) { return v === 'front' || v === 'back'; });
    if (!SIDES.length) SIDES = ['front', 'back'];
    ZONES = { front: BASE_ZONES.front, back: BASE_ZONES.back }; DEFAULT_ZONE = { front: BASE_DEFAULT.front, back: BASE_DEFAULT.back };
    ['front', 'back'].forEach(function (v) {
      var z = pa.zones && pa.zones[v];
      CUSTOM[v] = !!(Array.isArray(z) && z.length);
      if (CUSTOM[v]) {
        ZONES[v] = z;
        var big = z.slice().sort(function (a, b) { return (b.box[2] * b.box[3]) - (a.box[2] * a.box[3]); })[0];
        DEFAULT_ZONE[v] = (pa.default && pa.default[v]) || (z.length > 1 ? big.id : z[0].id);
      }
    });
  }
  var SIZE_NAME = { S: 'Small', A4: 'A4', A3: 'A3' };
  var PROPS = ['inkKind', 'inkName', 'inkZone', 'inkSeq'];
  var SEQ = 0;
  function nextSeq() { SEQ = Math.max(SEQ + 1, Date.now()); return SEQ; }
  function zoneById(view, id) { return (ZONES[view] || []).filter(function (z) { return z.id === id; })[0] || null; }
  var W = 800;
  var fabricPromise = null;

  function loadFabric(src) {
    if (window.fabric) return Promise.resolve();
    if (fabricPromise) return fabricPromise;
    fabricPromise = new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = src; s.async = true; s.crossOrigin = 'anonymous';
      s.onload = res; s.onerror = function () { fabricPromise = null; rej(new Error('Could not load the designer')); };
      document.head.appendChild(s);
      if (!document.querySelector('link[data-ink-fonts]')) {
        var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = FONT_CSS; l.setAttribute('data-ink-fonts', ''); document.head.appendChild(l);
      }
    });
    return fabricPromise;
  }
  // Fabric always calls preventDefault on touchstart, which blocks page scrolling over the canvas.
  // Only let Fabric see a touch when it starts on the selected item (or its handles), or in Edit mode.
  function patchFabricTouch(fabric) {
    var P = fabric.Canvas.prototype;
    if (P._inkPatched) return;
    var orig = P._onTouchStart;
    P._onTouchStart = function (e) {
      if (this.inkGate && !this.inkGate(e)) return;
      return orig.call(this, e);
    };
    var origMove = P._onMouseMove;
    P._onMouseMove = function (e) {
      if (e && e.touches && e.touches.length > 1) return; // two fingers = our pinch/rotate
      return origMove.call(this, e);
    };
    P._inkPatched = true;
  }
  function ensureFont(f) {
    if (!document.fonts || !document.fonts.load) return Promise.resolve();
    return document.fonts.load((FONTS[f] || 400) + ' 48px "' + f + '"').catch(function () {});
  }
  function px(u, w) { return String(u).replace(/([?&])width=\d+/, '$1width=' + w); }
  function abs(u) { return u && u.indexOf('//') === 0 ? 'https:' + u : u; }
  function loadImg(src) {
    return new Promise(function (res, rej) { var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function () { res(i); }; i.onerror = rej; i.src = abs(src); });
  }
  function sampleColour(src) {
    return loadImg(px(src, 120)).then(function (img) {
      var c = document.createElement('canvas'); c.width = 40; c.height = 40;
      var x = c.getContext('2d'); x.drawImage(img, 0, 0, 40, 40);
      var d = x.getImageData(16, 16, 8, 8).data, r = 0, g = 0, b = 0;
      for (var i = 0; i < d.length; i += 4) { r += d[i]; g += d[i + 1]; b += d[i + 2]; }
      var n = d.length / 4; return [r / n, g / n, b / n];
    }).catch(function () { return null; });
  }
  function dist(a, b) { return a && b ? Math.pow(a[0] - b[0], 2) + Math.pow(a[1] - b[1], 2) + Math.pow(a[2] - b[2], 2) : 1e9; }
  function rgb(c) { return c ? 'rgb(' + c.map(Math.round).join(',') + ')' : '#ccc'; }
  function lum(c) { return c ? (0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2]) : 255; }
  function el(tag, attrs, html) { var e = document.createElement(tag); for (var k in attrs || {}) e.setAttribute(k, attrs[k]); if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function toBlob(canvasEl) { return new Promise(function (res) { canvasEl.toBlob(res, 'image/png'); }); }

  function Designer(root) {
    this.root = root;
    this.d = JSON.parse(document.getElementById('InkDesignerData-' + root.dataset.section).textContent);
    this.q = function (s) { return root.querySelector(s); };
    this.view = 'front';
    this.store = { front: [], back: [] };
    this.hist = { front: { u: [], r: [] }, back: { u: [], r: [] } };
    this.ink = INKS[0][1]; this.outline = '';
    this.rights = false; this.rightsAt = '';
    this.editMode = false;
    this.qty = {};
    this.ready = null;
    this.setupData();
    this.buildUI();
    this.bind();
    this.renderPrice();
    var self = this;
    var start = function () { self.init(); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true }); } }, { rootMargin: '300px' });
      io.observe(this.q('[data-stage]'));
    } else start();
    if (window.PD_BOOT) window.PD_BOOT.enabled = '0';
    // Upload-Lift app embed injects its own upload fields into every product form; the designer replaces it here.
    var form = this.q('[data-ink-form]'), strip = function () { form.querySelectorAll('.upload-container,.cl-upload--wrapper').forEach(function (n) { n.remove(); }); };
    strip(); if ('MutationObserver' in window) new MutationObserver(strip).observe(form, { childList: true, subtree: true });
  }

  Designer.prototype.setupData = function () {
    var d = this.d, ci = d.colourIndex, si = d.sizeIndex, self = this;
    applyPrintArea(d.printArea); this.sides = SIDES.slice();
    var sel = d.variants.filter(function (v) { return v.id === d.selectedVariant; })[0] || d.variants[0];
    this.colours = []; this.sizes = [];
    d.variants.forEach(function (v) {
      var c = ci >= 0 ? v.options[ci] : '_', s = si >= 0 ? v.options[si] : (v.options.length > (ci >= 0 ? 1 : 0) ? v.title : 'One size');
      if (self.colours.indexOf(c) < 0) self.colours.push(c);
      if (self.sizes.indexOf(s) < 0) self.sizes.push(s);
    });
    if (si < 0 && ci < 0) this.sizes = ['One size'];
    this.colour = ci >= 0 ? sel.options[ci] : '_';
    this.qty[si >= 0 ? sel.options[si] : this.sizes[0]] = 1;
    var firstMedia = d.media[0] || {};
    this.ratio = 1 / ((d.media.filter(function (m) { return m.id === sel.imageId; })[0] || firstMedia).ratio || 1);
    this.H = Math.round(W * this.ratio);
    // front image per colour, back image matched later by colour sampling
    this.img = {};
    this.colours.forEach(function (c) {
      var v = d.variants.filter(function (x) { return (ci < 0 || x.options[ci] === c) && x.image; })[0];
      self.img[c] = { front: v ? v.image : (firstMedia.src || null), back: null };
    });
    var used = d.variants.map(function (v) { return v.imageId; });
    this.backCandidates = d.media.filter(function (m) { return used.indexOf(m.id) < 0 && /back|_bk\b|_bk\.|rear/i.test((m.src || '') + ' ' + (m.alt || '')); });
  };

  Designer.prototype.matchBacks = function () {
    var self = this, cands = this.backCandidates;
    return Promise.all(this.colours.map(function (c) { return sampleColour(self.img[c].front); })).then(function (fc) {
      self.colours.forEach(function (c, i) { self.img[c].rgb = fc[i]; });
      self.paintGarmentSwatches();
      if (!cands.length) return;
      if (cands.length === 1) { self.colours.forEach(function (c) { self.img[c].back = cands[0].src; }); return; }
      return Promise.all(cands.map(function (m) { return sampleColour(m.src); })).then(function (bc) {
        self.colours.forEach(function (c) {
          var best = 0; bc.forEach(function (x, j) { if (dist(x, self.img[c].rgb) < dist(bc[best], self.img[c].rgb)) best = j; });
          self.img[c].back = cands[best].src;
        });
      });
    });
  };

  Designer.prototype.area = function (view) {
    var pa = this.d.printArea, hood = this.d.isHood;
    if (typeof pa === 'string') { try { pa = JSON.parse(pa); } catch (e) { pa = null; } }
    var def = view === 'front'
      ? (hood ? { x: 0.33, y: 0.27, w: 0.34, cm_w: 30, cm_h: 28 } : { x: 0.32, y: 0.24, w: 0.36, cm_w: 30, cm_h: 40 })
      : (hood ? { x: 0.32, y: 0.30, w: 0.36, cm_w: 30, cm_h: 40 } : { x: 0.32, y: 0.21, w: 0.36, cm_w: 30, cm_h: 40 });
    var a = Object.assign({}, def, (pa && pa[view]) || {});
    var cmW = +(a.cm_w || a.cmW || 30), cmH = +(a.cm_h || a.cmH || 40);
    var aw = a.w * W, ah = a.h ? a.h * this.H : aw * cmH / cmW;
    return { x: a.x * W, y: a.y * this.H, w: aw, h: ah, cmW: cmW, cmH: cmH, ppc: aw / cmW };
  };
  Designer.prototype.zoneBox = function (view, id) {
    var a = this.area(view), z = zoneById(view, id) || zoneById(view, DEFAULT_ZONE[view]), off = CUSTOM[view] ? 0 : (a.cmW - 30) / 2;
    var x0 = Math.max(0, z.box[0] + off), y0 = Math.max(0, z.box[1]);
    var x1 = Math.min(a.cmW, z.box[0] + off + z.box[2]), y1 = Math.min(a.cmH, z.box[1] + z.box[3]);
    if (!CUSTOM[view] && z.box[2] >= 30) { x0 = 0; x1 = a.cmW; }
    return { x: a.x + x0 * a.ppc, y: a.y + y0 * a.ppc, w: (x1 - x0) * a.ppc, h: (y1 - y0) * a.ppc, cmW: x1 - x0, cmH: y1 - y0, ppc: a.ppc, zone: z };
  };
  Designer.prototype.priceOf = function (size) { var p = this.d.extraPrices || {}; return Math.round(parseFloat(p[size] || 0) * 100); };

  /* ---------- UI ---------- */
  Designer.prototype.buildUI = function () {
    var self = this;
    var cw = this.q('[data-colours]'), ow = this.q('[data-outlines]');
    INKS.forEach(function (c, i) {
      var b = el('button', { type: 'button', role: 'radio', 'class': 'ink-des__sw', 'aria-label': c[0], title: c[0], 'aria-checked': i === 0 ? 'true' : 'false', 'data-ink': c[1], style: 'background:' + c[1] });
      cw.appendChild(b);
    });
    OUTLINES.forEach(function (c, i) {
      var b = el('button', { type: 'button', role: 'radio', 'class': 'ink-des__sw' + (c[1] ? '' : ' ink-des__sw--none'), 'aria-label': c[0], title: c[0], 'aria-checked': i === 0 ? 'true' : 'false', 'data-outline': c[1] });
      if (c[1]) b.style.background = '#fff', b.style.boxShadow = 'inset 0 0 0 7px ' + c[1];
      ow.appendChild(b);
    });
    var g = this.q('[data-garments]');
    if (g) this.colours.forEach(function (c) {
      g.appendChild(el('button', { type: 'button', role: 'radio', 'class': 'ink-des__garment', 'aria-label': c, title: c, 'aria-checked': c === self.colour ? 'true' : 'false', 'data-garment': c, style: 'background:#ddd' }));
    });
    this.renderZones();
    this.renderSizes();
    if (this.sides.length < 2) this.root.querySelectorAll('[data-view]').forEach(function (b) { if (self.sides.indexOf(b.dataset.view) < 0) b.hidden = true; });
  };
  Designer.prototype.paintGarmentSwatches = function () {
    var self = this;
    this.root.querySelectorAll('[data-garment]').forEach(function (b) { b.style.background = rgb(self.img[b.dataset.garment].rgb); });
  };
  // Position picker: rendered in the Position tab and in the pop-up shown after adding an item.
  Designer.prototype.currentZone = function () {
    var o = this.canvas && this.canvas.getActiveObject();
    if (o && o.type === 'activeSelection') o = o.getObjects()[0];
    if (!o) { var objs = this.objects(); o = objs[objs.length - 1]; }
    return o ? this.view + ':' + (o.inkZone || DEFAULT_ZONE[this.view]) : '';
  };
  Designer.prototype.renderZones = function () {
    var self = this, cur = this.currentZone();
    this.root.querySelectorAll('[data-zones]').forEach(function (w) {
      var h = '';
      self.sides.forEach(function (v) {
        if (self.sides.length > 1) h += '<p class="ink-des__zgroup">' + (v === 'front' ? 'Front' : 'Back') + '</p>';
        h += '<div class="ink-des__zones">';
        ZONES[v].forEach(function (z) {
          var key = v + ':' + z.id, on = key === cur;
          h += '<button type="button" class="ink-des__zone' + (on ? ' is-active' : '') + '" aria-pressed="' + on + '" data-zone="' + key + '"><strong>' + esc(z.name) + '</strong><small>' + esc(z.hint) + ' · extra ' + self.money(self.priceOf(z.size)) + '</small></button>';
        });
        h += '</div>';
      });
      w.innerHTML = h;
    });
  };
  Designer.prototype.showPicker = function (on) {
    var p = this.q('[data-picker]'); if (!p) return;
    p.hidden = !on;
    if (on) { this.renderZones(); var r = p.getBoundingClientRect(); if (r.bottom > window.innerHeight || r.top < 0) p.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
  };
  Designer.prototype.variantFor = function (size) {
    var d = this.d, ci = d.colourIndex, si = d.sizeIndex, c = this.colour;
    return d.variants.filter(function (v) {
      return (ci < 0 || v.options[ci] === c) && (si < 0 ? (size === 'One size' || v.title === size) : v.options[si] === size);
    })[0] || (si < 0 && ci < 0 ? d.variants[0] : null);
  };
  Designer.prototype.renderSizes = function () {
    var w = this.q('[data-sizes]'), self = this, sid = this.root.dataset.section; w.innerHTML = '';
    this.sizes.forEach(function (s, i) {
      var v = self.variantFor(s), ok = v && v.available, q = ok ? (self.qty[s] || 0) : 0;
      if (!ok) self.qty[s] = 0;
      var id = 'InkQ-' + sid + '-' + i;
      var box = el('div', { 'class': 'ink-des__size' + (ok ? '' : ' ink-des__size--off') + (q ? ' has-qty' : '') });
      box.innerHTML = '<label for="' + id + '">' + esc(s) + '</label>' +
        '<div class="ink-des__q"><button type="button" data-step="-1" data-size="' + esc(s) + '" aria-label="One fewer ' + esc(s) + '"' + (ok ? '' : ' disabled') + '>−</button>' +
        '<input type="number" inputmode="numeric" min="0" max="999" id="' + id + '" value="' + q + '" data-size="' + esc(s) + '"' + (ok ? '' : ' disabled') + '>' +
        '<button type="button" data-step="1" data-size="' + esc(s) + '" aria-label="One more ' + esc(s) + '"' + (ok ? '' : ' disabled') + '>+</button></div>' +
        '<small>' + (ok ? self.money(v.price) : 'Sold out') + '</small>';
      w.appendChild(box);
    });
  };
  Designer.prototype.money = function (cents) {
    var f = this.d.moneyFormat || '£{{amount}}', a = (cents / 100).toFixed(2);
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, a.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  };
  Designer.prototype.sidesUsed = function () {
    var self = this;
    return ['front', 'back'].filter(function (v) { return v === self.view && self.canvas ? self.objects().length > 0 : self.store[v].length > 0; });
  };
  // Each distinct position used is one print. The FIRST print placed (front or back) is included in the garment price;
  // every other print is an extra at its size price. Placement order comes from inkSeq on each item, so if the first
  // item is deleted the next earliest print becomes the included one.
  Designer.prototype.prints = function () {
    var self = this, out = [], seen = {};
    ['front', 'back'].forEach(function (v) {
      var list = (v === self.view && self.canvas) ? self.objects() : self.store[v];
      list.forEach(function (o) {
        var z = zoneById(v, o.inkZone) || zoneById(v, DEFAULT_ZONE[v]), k = v + ':' + z.id, seq = +o.inkSeq || Infinity;
        if (seen[k]) { seen[k].seq = Math.min(seen[k].seq, seq); return; }
        seen[k] = { view: v, id: z.id, name: z.name, size: z.size, cents: self.priceOf(z.size), seq: seq };
        out.push(seen[k]);
      });
    });
    return out.sort(function (a, b) { return a.seq - b.seq; });
  };
  Designer.prototype.calc = function () {
    var self = this, n = 0, garments = 0;
    this.sizes.forEach(function (s) { var q = self.qty[s] || 0, v = self.variantFor(s); if (q && v) { n += q; garments += q * v.price; } });
    var prints = this.prints(), included = null, extras = [];
    included = prints[0] || null; // sorted by placement order
    prints.forEach(function (p) { if (p !== included) extras.push(p); });
    var perGarment = extras.reduce(function (s, p) { return s + p.cents; }, 0);
    // extra print basket lines, one per print size
    var bySize = {};
    extras.forEach(function (p) { (bySize[p.size] = bySize[p.size] || { size: p.size, cents: p.cents, names: [] }).names.push(p.name); });
    var groups = ['S', 'A4', 'A3'].filter(function (s) { return bySize[s]; }).map(function (s) { return bySize[s]; });
    return { n: n, garments: garments, sides: this.sidesUsed(), prints: prints, included: included, extras: extras, groups: groups, print: n * perGarment, total: garments + n * perGarment };
  };
  Designer.prototype.renderPrice = function () {
    var c = this.calc(), L = this.q('[data-price-lines]'), h = '', self = this;
    h += '<div><span>Garment' + (c.n === 1 ? '' : 's') + ' × ' + c.n + '</span><span>' + this.money(c.garments) + '</span></div>';
    if (!c.prints.length) h += '<div class="is-muted"><span>Add your design – your first print is included</span><span></span></div>';
    else {
      h += '<div class="is-muted"><span>' + 'First print included – ' + esc(c.included.name) + '</span><span>' + this.money(0) + '</span></div>';
      c.extras.forEach(function (p) {
        h += '<div data-extra-line><span>Extra print – ' + esc(p.name) + ' (' + SIZE_NAME[p.size] + ') ' + self.money(p.cents) + ' × ' + c.n + '</span><span>' + self.money(p.cents * c.n) + '</span></div>';
      });
    }
    L.innerHTML = h;
    this.q('[data-total]').textContent = this.money(c.total);
    var sp = document.querySelector('.ink-satc__price'); if (sp && c.n) sp.innerHTML = this.money(c.total) + ' <small class="ink-vat" style="font-size:.85em;font-weight:400;opacity:.75;letter-spacing:0;text-transform:none;">No VAT to add · ' + c.n + ' item' + (c.n > 1 ? 's' : '') + '</small>';
    ['front', 'back'].forEach(function (v) { var dot = self.q('[data-side-dot="' + v + '"]'); if (dot) dot.hidden = c.sides.indexOf(v) < 0; });
  };
  Designer.prototype.status = function (msg, bad) {
    var s = this.q('[data-status]'); s.textContent = msg || ''; s.classList.toggle('is-bad', !!bad);
  };

  /* ---------- Events ---------- */
  Designer.prototype.bind = function () {
    var self = this, root = this.root;
    root.addEventListener('click', function (e) {
      var t = e.target.closest('button,a'); if (!t || !root.contains(t)) return;
      if (t.dataset.tool) return self.tab(t.dataset.tool);
      if (t.dataset.view) return self.withCanvas(function () { self.switchView(t.dataset.view); });
      if (t.dataset.ink) { self.ink = t.dataset.ink; self.radio(t, '[data-ink]'); return self.withCanvas(function () { self.applyStyle({ fill: self.ink }); }); }
      if (t.hasAttribute('data-outline')) { self.outline = t.dataset.outline; self.radio(t, '[data-outline]'); return self.withCanvas(function () { self.applyStyle({ stroke: self.outline || null, strokeWidth: self.outline ? 3 : 0 }, true); }); }
      if (t.dataset.art) return self.withCanvas(function () { self.addArt(t.dataset.art, t.getAttribute('title')); });
      if (t.hasAttribute('data-add-text')) return self.withCanvas(function () { self.addText(); });
      if (t.dataset.zone) return self.withCanvas(function () { self.applyZone(t.dataset.zone); });
      if (t.hasAttribute('data-picker-done')) return self.showPicker(false);
      if (t.hasAttribute('data-edit-toggle')) return self.setEdit(!self.editMode);
      if (t.dataset.act) return self.withCanvas(function () { self.act(t.dataset.act); });
      if (t.dataset.garment) { self.radio(t, '[data-garment]'); return self.setColour(t.dataset.garment); }
      if (t.dataset.step) { var s = t.dataset.size; self.qty[s] = Math.max(0, Math.min(999, (self.qty[s] || 0) + (+t.dataset.step))); self.renderSizes(); self.renderPrice(); var inp = root.querySelector('input[data-size="' + CSS.escape(s) + '"]'); if (inp) inp.closest('.ink-des__q').querySelector('[data-step="' + t.dataset.step + '"]').focus(); return; }
      if (t.hasAttribute('data-open-size-guide')) { e.preventDefault(); var sg = document.querySelector('details[id^="Details-ink-sg-"]'); if (sg) { sg.open = true; sg.scrollIntoView({ behavior: 'smooth', block: 'start' }); } }
    });
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('input[data-size]')) { self.qty[t.dataset.size] = Math.max(0, Math.min(999, parseInt(t.value, 10) || 0)); self.renderSizes(); self.renderPrice(); }
      if (t.matches('[data-upload]') && t.files && t.files[0]) { var f = t.files[0]; t.value = ''; if (!self.rights) return self.needRights(); self.withCanvas(function () { self.upload(f); }); }
      if (t.matches('[data-rights]')) self.setRights(t.checked);
      if (t.matches('[data-font]')) self.withCanvas(function () { ensureFont(t.value).then(function () { self.applyStyle({ fontFamily: t.value, fontWeight: FONTS[t.value] || 400 }, true); }); });
    });
    var ti = this.q('[data-text-input]');
    ti.addEventListener('input', function () { var o = self.canvas && self.canvas.getActiveObject(); if (o && o.inkKind === 'text') { o.set('text', ti.value || ' '); self.clamp(o); self.canvas.requestRenderAll(); self.dirty(); } });
    ti.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); self.withCanvas(function () { self.addText(); }); } });
    // type=button on purpose: the Upload-Lift app embed blocks submit buttons on product forms it targets.
    this.q('[data-ink-form]').addEventListener('submit', function (e) { e.preventDefault(); self.withCanvas(function () { self.addToCart(); }); });
    this.q('[data-atc]').addEventListener('click', function (e) { e.preventDefault(); self.withCanvas(function () { self.addToCart(); }); });
    this.sticky();
    this.setRights(false);
    // Upload needs the rights box ticked first.
    var drop = this.q('.ink-des__drop');
    if (drop) drop.addEventListener('click', function (e) { if (!self.rights) { e.preventDefault(); self.needRights(); } });
    var stage = this.q('[data-stage]');
    stage.setAttribute('tabindex', '0');
    stage.setAttribute('aria-label', 'Design area. Use arrow keys to move the selected item, Delete to remove it.');
    stage.addEventListener('keydown', function (e) {
      var c = self.canvas, o = c && c.getActiveObject(); if (!o || o.isEditing) return;
      var step = e.shiftKey ? 10 : 2, mv = { ArrowLeft: [-step, 0], ArrowRight: [step, 0], ArrowUp: [0, -step], ArrowDown: [0, step] }[e.key];
      if (mv) { e.preventDefault(); o.left += mv[0]; o.top += mv[1]; self.clamp(o); c.requestRenderAll(); self.dirty(); }
      if (e.key === 'Delete' || e.key === 'Backspace') { e.preventDefault(); self.act('delete'); }
      if (e.key === 'Tab' && !e.shiftKey && false) {}
    });
  };
  // Drive the template's sticky "Add to basket" bar (its own script looks for a submit button, which we don't use).
  Designer.prototype.sticky = function () {
    var bar = document.querySelector('.ink-satc'), btn = this.q('[data-atc]'), self = this;
    if (!bar || !btn) return;
    bar.hidden = false; this.stickyBar = bar;
    var ticking = false;
    var upd = function () { ticking = false; var r = btn.getBoundingClientRect(); bar.classList.toggle('is-visible', r.bottom < 0 || r.top > window.innerHeight); };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    window.addEventListener('resize', upd); upd();
    var sb = bar.querySelector('button');
    if (sb) { sb.textContent = 'Add to basket'; sb.addEventListener('click', function () { self.withCanvas(function () { self.addToCart(); }); }); }
  };
  Designer.prototype.setRights = function (on) {
    this.rights = !!on;
    this.rightsAt = on ? new Date().toISOString() : '';
    this.root.querySelectorAll('[data-rights]').forEach(function (c) { c.checked = !!on; });
    var up = this.q('[data-upload]'); if (up) up.disabled = !on;
    var drop = this.q('.ink-des__drop'); if (drop) drop.classList.toggle('is-locked', !on);
    var btn = this.q('[data-atc]'); if (btn && !btn.hasAttribute('aria-busy')) btn.disabled = !on;
    var sb = this.stickyBar && this.stickyBar.querySelector('button'); if (sb) sb.disabled = !on;
    var hint = this.q('[data-rights-hint]'); if (hint) hint.hidden = !!on;
    if (on) { var e = this.q('[data-error]'); if (e && /rights/.test(e.textContent)) e.hidden = true; }
  };
  Designer.prototype.needRights = function () {
    this.status('Please tick the artwork rights box first.', true);
    var box = this.q('[data-panel="upload"] [data-rights]'); if (box) box.focus();
  };
  Designer.prototype.setEdit = function (on) {
    this.editMode = !!on;
    this.q('[data-stage]').classList.toggle('is-editing', this.editMode);
    var b = this.q('[data-edit-toggle]');
    if (b) { b.setAttribute('aria-pressed', this.editMode ? 'true' : 'false'); b.textContent = this.editMode ? 'Done editing' : 'Edit design'; }
  };
  Designer.prototype.radio = function (btn, sel) {
    this.root.querySelectorAll(sel).forEach(function (b) { b.setAttribute('aria-checked', b === btn ? 'true' : 'false'); });
  };
  Designer.prototype.tab = function (name) {
    this.root.querySelectorAll('[data-tool]').forEach(function (b) { var on = b.dataset.tool === name; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
    this.root.querySelectorAll('[data-panel]').forEach(function (p) { p.hidden = p.dataset.panel !== name; });
    if (name === 'text') this.withCanvas(function () {});
  };
  Designer.prototype.withCanvas = function (fn) {
    var self = this;
    (this.ready || this.init()).then(function () { fn(); }).catch(function (e) { self.status(e.message || 'Something went wrong', true); });
  };

  /* ---------- Canvas ---------- */
  Designer.prototype.init = function () {
    if (this.ready) return this.ready;
    var self = this;
    this.ready = Promise.all([loadFabric(this.d.fabricSrc), this.matchBacks()]).then(function () {
      var fabric = window.fabric, stage = self.q('[data-stage]');
      var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      self.coarse = coarse;
      fabric.Object.prototype.set({ transparentCorners: false, cornerColor: '#D4AF37', cornerStrokeColor: '#0D0D0D', borderColor: '#D4AF37', cornerStyle: 'circle', cornerSize: coarse ? 30 : 14, touchCornerSize: coarse ? 44 : 36, padding: coarse ? 12 : 4, borderScaleFactor: coarse ? 2 : 1 });
      patchFabricTouch(fabric);
      var ce = el('canvas', { 'aria-hidden': 'true' }); stage.appendChild(ce);
      var c = self.canvas = new fabric.Canvas(ce, { width: W, height: self.H, preserveObjectStacking: true, backgroundColor: '#ffffff', selection: true, enableRetinaScaling: true, uniformScaling: true, allowTouchScrolling: false });
      // Touch gate: a touch on an item or the selected item's handles goes to the designer (no page scroll);
      // a swipe that starts on the bare garment scrolls the page.
      c.inkGate = function (e) {
        if (e.touches && e.touches.length > 1) return false;
        c.calcOffset();
        var t = c.findTarget(e, false);
        var ok = self.editMode || (!!t && !t.excludeFromExport);
        self.touchOwn = ok;
        return ok;
      };
      self.touchSetup(stage);
      ['pointerdown', 'mousedown', 'touchstart'].forEach(function (ev) { stage.addEventListener(ev, function () { c.calcOffset(); }, { capture: true, passive: true }); });
      window.addEventListener('resize', function () { c.calcOffset(); });
      // Smooth clamp while dragging/resizing: moves are kept inside the item's own zone, and a resize or rotate that
      // would leave the zone simply stops at the last good size. Nothing is repositioned after the finger lifts.
      var keep = function (o) { o._inkGood = { left: o.left, top: o.top, scaleX: o.scaleX, scaleY: o.scaleY, angle: o.angle }; };
      c.on('mouse:down', function (e) { if (e.target) keep(e.target); });
      c.on('object:moving', function (e) { if (e.target) self.clampMove(e.target); });
      var limit = function (e) {
        var o = e.target; if (!o) return;
        if (self.fits(o)) keep(o);
        else if (o._inkGood) { o.set(o._inkGood); o.setCoords(); }
        if (e.transform) self.dpiCheck(o);
      };
      c.on('object:scaling', limit); c.on('object:rotating', limit);
      c.on('object:modified', function (e) { self.dpiCheck(e.target); self.dirty(); });
      c.on('text:changed', function (e) { self.clamp(e.target); self.q('[data-text-input]').value = e.target.text; self.dirty(); });
      c.on('selection:created', function () { self.onSelect(); }); c.on('selection:updated', function () { self.onSelect(); }); c.on('selection:cleared', function () { self.onSelect(); });
      self.pinch(stage);
      return self.setBackground(self.view).then(function () {
        self.drawGuide();
        var ph = stage.querySelector('.ink-des__placeholder'); if (ph) ph.style.visibility = 'hidden';
        var ld = stage.querySelector('[data-loading]'); if (ld) ld.remove();
        var eb = self.q('[data-edit-toggle]'); if (eb) eb.hidden = false;
        self.snapshot(true);
        self.updateButtons();
      });
    });
    this.ready.catch(function (e) { self.ready = null; self.status('The designer could not load. Please refresh, or email us your artwork.', true); });
    return this.ready;
  };
  Designer.prototype.setBackground = function (view) {
    var self = this, c = this.canvas, im = this.img[this.colour] || {}, src = (view === 'back' && im.back) || im.front;
    this.noBackPhoto = view === 'back' && !im.back;
    return new Promise(function (res) {
      if (!src) { c.setBackgroundImage(null, c.renderAll.bind(c)); return res(); }
      window.fabric.Image.fromURL(abs(src), function (img) {
        if (!img || !img.width) return res();
        var s = Math.min(W / img.width, self.H / img.height);
        img.set({ scaleX: s, scaleY: s, left: (W - img.width * s) / 2, top: (self.H - img.height * s) / 2, originX: 'left', originY: 'top' });
        c.setBackgroundImage(img, function () { c.requestRenderAll(); res(); });
      }, { crossOrigin: 'anonymous' });
    }).then(function () {
      self.status(self.noBackPhoto ? 'No back photo for this garment yet, so the front photo is shown as a guide.' : '');
    });
  };
  Designer.prototype.drawGuide = function () {
    var c = this.canvas, fabric = window.fabric;
    if (this.guide) c.remove(this.guide), c.remove(this.guideLabel);
    if (this.zoneRect) c.remove(this.zoneRect), c.remove(this.zoneLabel), this.zoneRect = null;
    var dark = lum((this.img[this.colour] || {}).rgb) < 110, col = dark ? 'rgba(255,255,255,.75)' : 'rgba(13,13,13,.55)';
    this.guide = new fabric.Rect({ left: 0, top: 0, width: 10, height: 10, fill: 'rgba(0,0,0,0)', stroke: col, strokeWidth: 1.5, strokeDashArray: [8, 6], selectable: false, evented: false, excludeFromExport: true, objectCaching: false, strokeUniform: true });
    this.guideLabel = new fabric.Text(' ', { left: 0, top: 0, originX: 'center', fontSize: 14, fontFamily: 'sans-serif', fill: col, selectable: false, evented: false, excludeFromExport: true });
    c.add(this.guide); c.add(this.guideLabel); c.sendToBack(this.guideLabel); c.sendToBack(this.guide);
    this.guideCol = col;
    this.drawZone();
  };
  // The dashed box shows the position of the selected item (or the last item added, or the side's default).
  function cmTxt(n) { return String(Math.round(n * 2) / 2).replace(/\.0$/, ''); }
  Designer.prototype.drawZone = function () {
    var c = this.canvas; if (!c || !this.guide) return;
    if (this.zoneRect) { c.remove(this.zoneRect); c.remove(this.zoneLabel); this.zoneRect = null; }
    var key = this.currentZone(), id = key ? key.split(':')[1] : DEFAULT_ZONE[this.view];
    var z = this.zoneBox(this.view, id);
    this.guide.set({ left: z.x, top: z.y, width: z.w, height: z.h }); this.guide.setCoords();
    this.guideLabel.set({ text: z.zone.name + ' ' + cmTxt(z.cmW) + ' × ' + cmTxt(z.cmH) + 'cm', left: z.x + z.w / 2, top: Math.max(2, z.y - 20) });
    this.guideZone = id;
    c.requestRenderAll();
  };
  Designer.prototype.objects = function () { return this.canvas ? this.canvas.getObjects().filter(function (o) { return !o.excludeFromExport; }) : []; };
  Designer.prototype.zoneOf = function (o) {
    var first = o.type === 'activeSelection' ? o.getObjects()[0] : o;
    return this.zoneBox(this.view, (first && first.inkZone) || DEFAULT_ZONE[this.view]);
  };
  Designer.prototype.fits = function (o) {
    var a = this.zoneOf(o); o.setCoords(); var b = o.getBoundingRect(true, true);
    return b.width <= a.w + 1 && b.height <= a.h + 1 && b.left >= a.x - 1 && b.top >= a.y - 1 && b.left + b.width <= a.x + a.w + 1 && b.top + b.height <= a.y + a.h + 1;
  };
  // Keep the item inside its zone by limiting the move (no scaling, no snapping).
  Designer.prototype.clampMove = function (o) {
    var a = this.zoneOf(o); o.setCoords(); var b = o.getBoundingRect(true, true), dx = 0, dy = 0;
    if (b.width > a.w) dx = a.x + a.w / 2 - (b.left + b.width / 2); else if (b.left < a.x) dx = a.x - b.left; else if (b.left + b.width > a.x + a.w) dx = a.x + a.w - b.left - b.width;
    if (b.height > a.h) dy = a.y + a.h / 2 - (b.top + b.height / 2); else if (b.top < a.y) dy = a.y - b.top; else if (b.top + b.height > a.y + a.h) dy = a.y + a.h - b.top - b.height;
    if (dx || dy) { o.left += dx; o.top += dy; o.setCoords(); }
  };
  Designer.prototype.clamp = function (o) {
    if (!o || !this.canvas) return;
    var first = o.type === 'activeSelection' ? o.getObjects()[0] : o;
    var a = this.zoneBox(this.view, (first && first.inkZone) || DEFAULT_ZONE[this.view]);
    o.setCoords(); var b = o.getBoundingRect(true, true);
    if (b.width > a.w + 0.5 || b.height > a.h + 0.5) {
      var f = Math.min(a.w / b.width, a.h / b.height);
      o.scaleX *= f; o.scaleY *= f; o.setCoords(); b = o.getBoundingRect(true, true);
    }
    var dx = 0, dy = 0;
    if (b.left < a.x) dx = a.x - b.left; else if (b.left + b.width > a.x + a.w) dx = a.x + a.w - b.left - b.width;
    if (b.top < a.y) dy = a.y - b.top; else if (b.top + b.height > a.y + a.h) dy = a.y + a.h - b.top - b.height;
    if (dx || dy) { o.left += dx; o.top += dy; o.setCoords(); }
  };
  // New items go into a default position, then the picker asks where it should go.
  Designer.prototype.place = function (o) {
    var c = this.canvas, objs = this.objects(), last = objs[objs.length - 1];
    o.set({ originX: 'center', originY: 'center', inkZone: (last && last.inkZone) || DEFAULT_ZONE[this.view], inkSeq: nextSeq() });
    c.add(o);
    this.fitZone(o, o.inkZone);
    c.setActiveObject(o);
    this.dirty();
    this.showPicker(true);
  };
  // Auto-size into a position: as big as fits, centred.
  Designer.prototype.fitZone = function (o, id) {
    var z = this.zoneBox(this.view, id);
    o.setCoords(); var b = o.getBoundingRect(true, true);
    var f = Math.min(z.w / b.width, z.h / b.height);
    o.scaleX *= f; o.scaleY *= f; o.setCoords(); b = o.getBoundingRect(true, true);
    o.left += (z.x + z.w / 2) - (b.left + b.width / 2); o.top += (z.y + z.h / 2) - (b.top + b.height / 2); o.setCoords();
    this.clamp(o);
  };
  Designer.prototype.applyZone = function (key) {
    var self = this, v = key.split(':')[0], id = key.split(':')[1], c = this.canvas;
    var o = c.getActiveObject();
    if (!o) { var objs = this.objects(); if (!objs.length) return this.status('Add a logo, text or clipart first.', true); o = objs[objs.length - 1]; c.setActiveObject(o); }
    var list = o.type === 'activeSelection' ? o.getObjects() : [o];
    if (v !== this.view) {
      // Move the item to the other side of the garment.
      var json = list.map(function (x) { var j = x.toObject(PROPS); if (o.type === 'activeSelection') { var m = x.calcTransformMatrix(), d = window.fabric.util.qrDecompose(m); j.left = d.translateX; j.top = d.translateY; j.scaleX = d.scaleX; j.scaleY = d.scaleY; j.angle = d.angle; j.originX = 'center'; j.originY = 'center'; } return j; });
      c.discardActiveObject(); list.forEach(function (x) { c.remove(x); }); this.snapshot();
      return this.switchView(v).then(function () {
        return new Promise(function (res) { window.fabric.util.enlivenObjects(json, res); });
      }).then(function (objs) {
        objs.forEach(function (x) { x.inkZone = id; c.add(x); });
        var t = objs.length > 1 ? new window.fabric.ActiveSelection(objs, { canvas: c }) : objs[0];
        self.fitZone(t, id); c.setActiveObject(t); c.discardActiveObject(); c.setActiveObject(objs[objs.length - 1]);
        self.afterZone(objs[objs.length - 1]);
      });
    }
    list.forEach(function (x) { x.inkZone = id; });
    this.fitZone(o, id);
    if (o.type === 'activeSelection') { c.discardActiveObject(); c.setActiveObject(list[list.length - 1]); }
    this.afterZone(c.getActiveObject());
  };
  Designer.prototype.afterZone = function (o) {
    this.canvas.requestRenderAll();
    this.dpiCheck(o && o.inkKind === 'image' ? o : null);
    this.dirty();
    var z = this.zoneBox(this.view, o.inkZone);
    this.status(z.zone.name + ' – drag or resize to fine-tune inside the gold box.');
    this.showPicker(false);
    this.drawZone();
    this.centreStage();
  };
  // After a position tap on a phone/tablet, smoothly bring the whole garment into view, centred.
  Designer.prototype.centreStage = function () {
    if (window.innerWidth >= 990) return;
    var st = this.q('[data-stage]'), r = st.getBoundingClientRect(), vh = window.innerHeight;
    var y = window.pageYOffset + r.top - Math.max(0, (vh - r.height) / 2);
    if (Math.abs(window.pageYOffset - y) > 4) window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  };
  Designer.prototype.upload = function (file) {
    var self = this, fabric = window.fabric;
    if (file.size > 20 * 1024 * 1024) return this.status('That file is over 20MB. Please use a smaller file or email it to us.', true);
    if (!/^image\/(png|jpeg|svg\+xml)$/.test(file.type) && !/\.(png|jpe?g|svg)$/i.test(file.name)) return this.status('Please upload a PNG, JPG or SVG file.', true);
    var r = new FileReader();
    if (/svg/i.test(file.type) || /\.svg$/i.test(file.name)) {
      r.onload = function () {
        fabric.loadSVGFromString(String(r.result), function (objs, opts) {
          if (!objs || !objs.length) return self.status('We could not read that SVG. Try a PNG instead.', true);
          var g = fabric.util.groupSVGElements(objs, opts); g.set({ inkKind: 'svg', inkName: file.name });
          self.place(g); self.status('Vector artwork added: this will print sharp at any size.'); self.bgNote(false);
        });
      };
      r.readAsText(file);
    } else {
      r.onload = function () {
        fabric.Image.fromURL(String(r.result), function (img) {
          if (!img || !img.width) return self.status('We could not read that image. Try another file.', true);
          img.set({ inkKind: 'image', inkName: file.name });
          self.place(img); self.dpiCheck(img); self.alphaCheck(img.getElement(), file);
        });
      };
      r.readAsDataURL(file);
    }
  };
  // Gentle note when a PNG/JPG has no transparent pixels: its background box will print too.
  Designer.prototype.alphaCheck = function (imgEl, file) {
    var transparent = false;
    if (!/jpe?g/i.test(file.type) && !/\.jpe?g$/i.test(file.name)) {
      try {
        var s = Math.min(1, 256 / Math.max(imgEl.naturalWidth || imgEl.width, imgEl.naturalHeight || imgEl.height));
        var cv = document.createElement('canvas'); cv.width = Math.max(1, Math.round((imgEl.naturalWidth || imgEl.width) * s)); cv.height = Math.max(1, Math.round((imgEl.naturalHeight || imgEl.height) * s));
        var x = cv.getContext('2d'); x.drawImage(imgEl, 0, 0, cv.width, cv.height);
        var d = x.getImageData(0, 0, cv.width, cv.height).data;
        for (var i = 3; i < d.length; i += 4) { if (d[i] < 250) { transparent = true; break; } }
      } catch (e) { transparent = true; }
    }
    this.bgNote(!transparent);
  };
  Designer.prototype.bgNote = function (show) {
    var n = this.q('[data-bg-note]'); if (n) n.hidden = !show;
  };
  Designer.prototype.dpiCheck = function (o) {
    var w = this.q('[data-dpi-warn]');
    if (!o || o.inkKind !== 'image') { if (!o) w.hidden = true; return; }
    var a = this.area(this.view), dpi = Math.round(2.54 * a.ppc / o.scaleX), wcm = (o.getScaledWidth() / a.ppc).toFixed(1);
    if (dpi < 150) {
      w.hidden = false;
      w.textContent = 'This image is a bit low resolution for its size (about ' + dpi + ' dpi at ' + wcm + 'cm wide) and may print blurry. Try making it smaller or uploading a bigger file. We print exactly what you place, so a blurry file prints blurry.';
      this.status('Low resolution: about ' + dpi + ' dpi', true);
    } else { w.hidden = true; this.status('Image quality looks good (about ' + Math.min(dpi, 999) + ' dpi at ' + wcm + 'cm wide).'); }
  };
  Designer.prototype.addText = function () {
    var self = this, fabric = window.fabric, ti = this.q('[data-text-input]'), txt = (ti.value || '').trim() || 'Your text', font = this.q('[data-font]').value;
    ensureFont(font).then(function () {
      var t = new fabric.IText(txt, { fontFamily: font, fontWeight: FONTS[font] || 400, fontSize: 64, fill: self.ink, stroke: self.outline || null, strokeWidth: self.outline ? 3 : 0, paintFirst: 'stroke', textAlign: 'center', inkKind: 'text' });
      self.place(t); ti.value = txt;
    });
  };
  Designer.prototype.addArt = function (d, name) {
    var p = new window.fabric.Path(d, { fill: this.ink, fillRule: 'evenodd', inkKind: 'clipart', inkName: name });
    this.place(p);
  };
  Designer.prototype.applyStyle = function (props, textOnly) {
    var c = this.canvas, o = c.getActiveObject(); if (!o) return;
    var list = o.type === 'activeSelection' ? o.getObjects() : [o];
    var changed = false;
    list.forEach(function (x) {
      if (x.inkKind === 'text' || (!textOnly && x.inkKind === 'clipart')) { x.set(props); if (x.inkKind === 'text') x.initDimensions && x.initDimensions(); x.setCoords(); changed = true; }
    });
    if (changed) { this.clamp(o); c.requestRenderAll(); this.dirty(); }
  };
  Designer.prototype.onSelect = function () {
    var o = this.canvas.getActiveObject();
    if (o && o.inkKind === 'text') {
      this.q('[data-text-input]').value = o.text; this.q('[data-font]').value = o.fontFamily;
      this.root.querySelectorAll('[data-ink]').forEach(function (b) { b.setAttribute('aria-checked', b.dataset.ink.toLowerCase() === String(o.fill).toLowerCase() ? 'true' : 'false'); });
    }
    this.dpiCheck(o && o.inkKind === 'image' ? o : null);
    this.updateButtons();
    this.renderZones(); this.drawZone();
  };
  Designer.prototype.withTarget = function () {
    var c = this.canvas, o = c.getActiveObject();
    if (o) return o;
    var objs = this.objects(); if (!objs.length) return null;
    if (objs.length === 1) return objs[0];
    var sel = new window.fabric.ActiveSelection(objs, { canvas: c }); c.setActiveObject(sel); return sel;
  };
  Designer.prototype.act = function (a) {
    var c = this.canvas, o = c.getActiveObject();
    if (a === 'undo' || a === 'redo') return this.history(a);
    if (a === 'centre') { o = this.withTarget(); if (!o) return; var first = o.type === 'activeSelection' ? o.getObjects()[0] : o, ar = this.zoneBox(this.view, first.inkZone), b = o.getBoundingRect(true, true); o.left += ar.x + ar.w / 2 - (b.left + b.width / 2); o.setCoords(); c.requestRenderAll(); return this.dirty(); }
    if (!o) return this.status('Tap an item on the shirt first.', true);
    if (a === 'delete') { (o.type === 'activeSelection' ? o.getObjects() : [o]).forEach(function (x) { c.remove(x); }); c.discardActiveObject(); c.requestRenderAll(); this.q('[data-dpi-warn]').hidden = true; this.bgNote(false); this.showPicker(false); return this.dirty(); }
    if (a === 'forward') c.bringForward(o);
    if (a === 'backward') { c.sendBackwards(o); var i = c.getObjects().indexOf(o); if (i < 2) c.moveTo(o, 2); }
    c.requestRenderAll(); this.dirty();
  };
  Designer.prototype.serialize = function () { return this.objects().map(function (o) { return o.toObject(PROPS); }); };
  Designer.prototype.snapshot = function (reset) {
    var h = this.hist[this.view], s = JSON.stringify(this.serialize());
    if (reset) { h.u = [s]; h.r = []; return; }
    if (h.u[h.u.length - 1] !== s) { h.u.push(s); if (h.u.length > 40) h.u.shift(); h.r = []; }
  };
  Designer.prototype.dirty = function () {
    this.snapshot(); this.updateButtons(); this.renderPrice(); this.renderZones(); this.drawZone();
  };
  Designer.prototype.restore = function (arr) {
    var self = this, c = this.canvas;
    return new Promise(function (res) {
      self.objects().forEach(function (o) { c.remove(o); });
      window.fabric.util.enlivenObjects(arr, function (objs) { objs.forEach(function (o) { c.add(o); }); c.discardActiveObject(); c.requestRenderAll(); res(); });
    });
  };
  Designer.prototype.history = function (dir) {
    var h = this.hist[this.view], self = this;
    if (dir === 'undo' && h.u.length > 1) h.r.push(h.u.pop());
    else if (dir === 'redo' && h.r.length) h.u.push(h.r.pop());
    else return;
    this.restore(JSON.parse(h.u[h.u.length - 1])).then(function () { self.updateButtons(); self.renderPrice(); self.renderZones(); self.drawZone(); });
  };
  Designer.prototype.updateButtons = function () {
    var h = this.hist[this.view], has = !!(this.canvas && this.canvas.getActiveObject()), any = this.objects().length > 0;
    var set = function (a, on) { var b = this.root.querySelector('[data-act="' + a + '"]'); if (b) b.disabled = !on; }.bind(this);
    set('undo', h.u.length > 1); set('redo', h.r.length > 0); set('delete', has); set('forward', has); set('backward', has); set('centre', any);
  };
  Designer.prototype.switchView = function (v, silent) {
    if (v === this.view) return Promise.resolve();
    var self = this;
    this.canvas.discardActiveObject();
    this.store[this.view] = this.serialize();
    this.view = v;
    if (!silent) {
      this.root.querySelectorAll('[data-view]').forEach(function (b) { var on = b.dataset.view === v; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
    }
    return this.setBackground(v).then(function () { self.drawGuide(); return self.restore(self.store[v]); }).then(function () {
      if (!self.hist[v].u.length) self.snapshot(true);
      self.updateButtons(); self.renderPrice(); self.renderZones(); self.drawZone();
    });
  };
  Designer.prototype.setColour = function (c) {
    this.colour = c;
    var n = this.q('[data-colour-name]'); if (n) n.textContent = c;
    this.renderSizes(); this.renderPrice();
    var self = this;
    this.withCanvas(function () { self.setBackground(self.view).then(function () { self.drawGuide(); }); });
  };
  // Touch handling on the stage: no page scroll while an item is being dragged/resized; a swipe that starts on the
  // bare garment scrolls the page (natively when nothing is selected, by hand when an item is selected).
  Designer.prototype.touchSetup = function (stage) {
    var self = this, c = this.canvas, pan = null;
    var sync = function () { stage.classList.toggle('has-selection', !!c.getActiveObject()); };
    c.on('selection:created', sync); c.on('selection:updated', sync); c.on('selection:cleared', sync);
    stage.addEventListener('touchstart', function (e) {
      pan = null;
      if (e.touches.length === 1 && !self.touchOwn && !self.editMode) pan = { y: e.touches[0].clientY, x: e.touches[0].clientX, moved: false };
    }, { passive: true, capture: false });
    stage.addEventListener('touchmove', function (e) {
      if (e.touches.length > 1) { if (c.getActiveObject()) e.preventDefault(); return; }
      if (self.touchOwn || self.editMode) { e.preventDefault(); return; }
      if (pan && stage.classList.contains('has-selection')) {
        e.preventDefault();
        var y = e.touches[0].clientY, dy = pan.y - y; pan.y = y;
        if (Math.abs(dy) > 0) { pan.moved = true; window.scrollBy(0, dy); }
      } else if (pan) pan.moved = true;
    }, { passive: false });
    stage.addEventListener('touchend', function (e) {
      // A tap (not a swipe) on the bare garment deselects, so the next swipe scrolls natively.
      if (pan && !pan.moved && e.touches.length === 0 && c.getActiveObject()) { c.discardActiveObject(); c.requestRenderAll(); }
      if (e.touches.length === 0) { self.touchOwn = false; pan = null; }
    }, { passive: true });
    this.pinch(stage);
  };
  Designer.prototype.pinch = function (stage) {
    var self = this, st = null;
    function info(t) { var a = t[0], b = t[1]; return { d: Math.hypot(b.clientX - a.clientX, b.clientY - a.clientY), ang: Math.atan2(b.clientY - a.clientY, b.clientX - a.clientX) * 180 / Math.PI }; }
    stage.addEventListener('touchstart', function (e) {
      var o = self.canvas && self.canvas.getActiveObject();
      if (e.touches.length === 2 && o) {
        var c = self.canvas; if (c._currentTransform) { c._currentTransform = null; }
        var i = info(e.touches), ctr = o.getCenterPoint();
        st = { o: o, d: i.d, ang: i.ang, sx: o.scaleX, sy: o.scaleY, a: o.angle || 0, cx: ctr.x, cy: ctr.y };
        o._inkGood = { left: o.left, top: o.top, scaleX: o.scaleX, scaleY: o.scaleY, angle: o.angle };
      }
    }, { passive: true });
    stage.addEventListener('touchmove', function (e) {
      if (!st || e.touches.length !== 2) return;
      e.preventDefault();
      var o = st.o, i = info(e.touches), f = i.d / st.d, z = self.zoneOf(o);
      var setTo = function (k) {
        o.set({ scaleX: st.sx * k, scaleY: st.sy * k, angle: st.a + (i.ang - st.ang) });
        o.setPositionByOrigin(new window.fabric.Point(st.cx, st.cy), 'center', 'center'); o.setCoords();
      };
      setTo(f);
      var b = o.getBoundingRect(true, true);
      if (b.width > z.w || b.height > z.h) { setTo(f * Math.min(z.w / b.width, z.h / b.height)); }
      self.clampMove(o); self.canvas.requestRenderAll();
    }, { passive: false });
    stage.addEventListener('touchend', function (e) { if (st && e.touches.length < 2) { self.dpiCheck(st.o); st = null; self.dirty(); } }, { passive: true });
  };

  /* ---------- Export + cart ---------- */
  Designer.prototype.exportSide = function (v) {
    var self = this, c = this.canvas;
    return this.switchView(v, true).then(function () {
      c.discardActiveObject();
      var a = self.area(v), objs = self.objects();
      self.guide.visible = false; self.guideLabel.visible = false;
      if (self.zoneRect) { c.remove(self.zoneRect); c.remove(self.zoneLabel); self.zoneRect = null; }
      c.renderAll();
      var mock = c.toCanvasElement(1000 / W);
      // tight crop around the artwork, inside the print area
      var l = Infinity, t = Infinity, r = -Infinity, btm = -Infinity;
      objs.forEach(function (o) { o.setCoords(); var b = o.getBoundingRect(true, true); l = Math.min(l, b.left); t = Math.min(t, b.top); r = Math.max(r, b.left + b.width); btm = Math.max(btm, b.top + b.height); });
      l = Math.max(l, a.x); t = Math.max(t, a.y); r = Math.min(r, a.x + a.w); btm = Math.min(btm, a.y + a.h);
      var bg = c.backgroundImage, bgc = c.backgroundColor;
      c.backgroundImage = null; c.backgroundColor = null;
      function render(dpi) {
        var m = Math.min((dpi / 2.54) / a.ppc, 4800 / Math.max(r - l, btm - t));
        return toBlob(c.toCanvasElement(m, { left: l, top: t, width: r - l, height: btm - t })).then(function (b) { return { blob: b, dpi: Math.round(m * a.ppc * 2.54) }; });
      }
      return toBlob(mock).then(function (mb) {
        return render(300).then(function (p) { return p.blob.size > 15e6 ? render(200) : p; }).then(function (p) { return p.blob.size > 15e6 ? render(150) : p; }).then(function (p) {
          c.backgroundImage = bg; c.backgroundColor = bgc; self.guide.visible = true; self.guideLabel.visible = true; c.requestRenderAll();
          var zs = []; objs.forEach(function (o) { var z = zoneById(v, o.inkZone) || zoneById(v, DEFAULT_ZONE[v]); if (zs.indexOf(z.name) < 0) zs.push(z.name); });
          return { view: v, mock: mb, print: p.blob, dpi: p.dpi, zones: zs, wcm: ((r - l) / a.ppc).toFixed(0), hcm: ((btm - t) / a.ppc).toFixed(0), json: self.serialize() };
        });
      });
    });
  };
  Designer.prototype.designJSON = function (sides) {
    var self = this, out = { v: 1, product: this.d.handle, colour: this.colour, sides: {} };
    sides.forEach(function (s) {
      out.sides[s.view] = { positions: s.zones, area: self.area(s.view), objects: s.json.map(function (o) { var x = Object.assign({}, o); if (x.type === 'image') x.src = '[uploaded: ' + (o.inkName || 'image') + ']'; return x; }) };
    });
    var j = JSON.stringify(out);
    if (j.length > 45000) {
      sides.forEach(function (s) { out.sides[s.view].objects = s.json.map(function (o) { return { type: o.type, kind: o.inkKind, name: o.inkName, text: o.text, fontFamily: o.fontFamily, fill: typeof o.fill === 'string' ? o.fill : null, zone: o.inkZone, left: Math.round(o.left), top: Math.round(o.top), scaleX: o.scaleX, angle: o.angle }; }); });
      j = JSON.stringify(out);
    }
    return j;
  };
  // One /cart/add.js call: a garment line per size (with the print files) plus Extra Print line(s).
  Designer.prototype.addToCart = function () {
    var self = this, form = this.q('[data-ink-form]'), btn = this.q('[data-atc]'), err = this.q('[data-error]');
    err.hidden = true;
    var calc = this.calc();
    var fail = function (m) { err.textContent = m; err.hidden = false; err.scrollIntoView({ behavior: 'smooth', block: 'center' }); btn.removeAttribute('aria-busy'); btn.disabled = !self.rights; btn.textContent = 'Add to basket'; };
    if (!this.rights) return fail('Please confirm you have the rights to use this artwork (tick the box above).');
    if (!calc.sides.length) return fail('Add your logo, text or clipart to the shirt first.');
    var lines = this.sizes.map(function (s) { return { size: s, q: self.qty[s] || 0, v: self.variantFor(s) }; }).filter(function (x) { return x.q > 0 && x.v && x.v.available; });
    if (!lines.length) return fail('Choose at least one size and quantity.');
    var extraVariants = {};
    if (calc.groups.length) {
      var xp = this.d.extraProduct;
      calc.groups.forEach(function (g) {
        var v = xp && xp.variants.filter(function (x) { return x.size === g.size && x.available; })[0];
        if (v) extraVariants[g.size] = v;
      });
      if (calc.groups.some(function (g) { return !extraVariants[g.size]; })) return fail('Extra prints can\'t be added right now. Please email support@inkaroo.co.uk and we\'ll sort your order.');
    }
    btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Saving your design…';
    var startView = this.view, sides = [];
    var chain = Promise.resolve();
    calc.sides.forEach(function (v) { chain = chain.then(function () { return self.exportSide(v).then(function (r) { sides.push(r); }); }); });
    chain.then(function () { return self.switchView(startView, true); }).then(function () {
      var ref = self.ref || (self.ref = 'INK-' + Date.now().toString(36).toUpperCase());
      var fd = new FormData(), n = 0;
      var tok = form.querySelector('input[name="form_type"]'); if (tok) fd.append('form_type', tok.value);
      var garmentName = self.d.title + (self.colour && self.colour !== '_' ? ' (' + self.colour + ')' : '');
      var positions = calc.prints.map(function (p) { return (p.view === 'front' ? 'Front' : 'Back') + ': ' + p.name + (p === calc.included ? ' (included)' : ' (extra, ' + SIZE_NAME[p.size] + ')'); }).join('; ');
      var sizesTxt = sides.map(function (s) { return (s.view === 'front' ? 'Front' : 'Back') + ' approx. ' + s.wcm + ' × ' + s.hcm + 'cm, print file ' + s.dpi + ' dpi'; }).join('; ');
      var extrasTxt = calc.extras.length ? calc.extras.map(function (p) { return p.name + ' (' + SIZE_NAME[p.size] + ') ' + self.money(p.cents); }).join(', ') + ' per garment – on the Extra Print line' : 'None';
      var rightsTxt = 'Confirmed ' + self.rightsAt;
      try { rightsTxt = 'Confirmed ' + new Date(self.rightsAt).toLocaleString('en-GB', { timeZone: 'Europe/London', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }) + ' UK time (' + self.rightsAt + ')'; } catch (e) {}
      // Hidden spec of this design's extra print lines, so the basket can restore them if one is removed on its own.
      var extrasSpec = JSON.stringify(calc.groups.map(function (g) { return { v: extraVariants[g.size].id, n: g.names.length, p: g.names.join(' + '), f: garmentName + ' – design ref ' + ref }; }));
      var addExtras = function () {
        calc.groups.forEach(function (g) {
          var p = 'items[' + n + ']', v = extraVariants[g.size];
          fd.append(p + '[id]', v.id); fd.append(p + '[quantity]', calc.n * g.names.length);
          fd.append(p + '[properties][For]', garmentName + ' – design ref ' + ref);
          fd.append(p + '[properties][Position]', g.names.join(' + '));
          fd.append(p + '[properties][_Design ref]', ref);
          fd.append(p + '[properties][_Per garment]', String(g.names.length));
          n++;
        });
      };
      // The basket shows the last-added line first, so extras go in first and sizes in reverse (reads S, M, L, then extras).
      addExtras();
      lines.slice().reverse().forEach(function (l) {
        var p = 'items[' + n + ']';
        fd.append(p + '[id]', l.v.id); fd.append(p + '[quantity]', l.q);
        var prop = function (k, v) { fd.append(p + '[properties][' + k + ']', v); };
        prop('Print positions', positions);
        prop('Print sizes', sizesTxt);
        prop('Extra prints', extrasTxt);
        prop('Artwork rights', rightsTxt);
        sides.forEach(function (s) {
          var Side = s.view === 'front' ? 'Front' : 'Back';
          fd.append(p + '[properties][' + Side + ' preview]', new File([s.mock], ref + '-' + s.view + '-preview.png', { type: 'image/png' }));
          fd.append(p + '[properties][' + Side + ' print file]', new File([s.print], ref + '-' + s.view + '-print.png', { type: 'image/png' }));
        });
        prop('_Design ref', ref);
        if (calc.groups.length) prop('_Extras', extrasSpec);
        prop('_Design JSON', self.designJSON(sides));
        n++;
      });
      btn.textContent = 'Adding to basket…';
      return fetch((self.d.cartAddUrl || '/cart/add') + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to basket'); return j; }); })
        .then(function (res) {
          var items = res.items || [res];
          var urlsOk = items.filter(function (i) { return i.properties && i.properties['_Design JSON']; }).every(function (i) { return Object.keys(i.properties).some(function (k) { return /print file$/.test(k) && /^(https?:)?\/\//.test(String(i.properties[k])); }); });
          window.InkDesignerLastAdd = { items: items, urlsOk: urlsOk, ref: ref };
          return res;
        });
    }).then(function () {
      self.ref = null;
      btn.textContent = 'Added. Going to your basket…';
      if (!self.root.hasAttribute('data-no-redirect')) window.location.href = self.d.cartUrl || '/cart';
      else { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.textContent = 'Add to basket'; }
    }).catch(function (e) {
      fail((e && e.message) || 'Sorry, something went wrong. Please try again or email support@inkaroo.co.uk.');
    });
  };

  function boot() { document.querySelectorAll('.ink-des[data-section]').forEach(function (r) { if (!r._ink) r._ink = new Designer(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
